<div id="products" class="page-layout carded fullwidth" fusePerfectScrollbar>

  <!-- TOP BACKGROUND -->
  <div class="top-bg mat-accent-bg"></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center">

    <!-- HEADER -->
    <div class="header white-fg"
      fxLayout="column" fxLayoutAlign="center center"
      fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center">

      <!-- APP TITLE -->
      <div class="logo my-12 m-sm-0"
        fxLayout="row" fxLayoutAlign="start center">

        <mat-icon class="logo-icon mr-16" *fuseIfOnDom [@animate]="{value:'*',params:{delay:'50ms',scale:'0.2'}}">
          apps
        </mat-icon>
        <span class="logo-text h1" *fuseIfOnDom
        [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">{{'main.eLearning' | translate}}</span>
      </div>
      <!-- / APP TITLE -->

      <!-- SEARCH -->
      <div class="search-input-wrapper mx-12 m-md-0"
        fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center">
        <label for="search" class="mr-8">
          <mat-icon class="secondary-text">search</mat-icon>
        </label>

        <!-- USE IT TO BLOCK CHROME AUTOCOMPLETE -->
        <mat-form-field floatLabel="never" fxFlex="1 0 auto" style="display: none">
          <input id="search1" autocomplete="off" matInput #filter2 placeholder="{{'main.search' | translate}}">
        </mat-form-field>
        <!-- USE IT TO BLOCK CHROME AUTOCOMPLETE -->

        <mat-form-field floatLabel="never" fxFlex="1 0 auto" class="page-search">
          <mat-label>{{'main.search' | translate}}</mat-label>
          <input id="search" matInput #filter>
        </mat-form-field>
      </div>
      <!-- / SEARCH -->
    </div>
    <!-- / HEADER -->


    <!-- CONTENT -->
    <div class="content-card mat-white-bg">
      <mat-table class="products-table"
        #table [dataSource]="eLearnings"
        id="recommendElearning"
        matSort
        [@animateStagger]="{value:'50'}"
        fusePerfectScrollbar>


        <!-- Name Column -->
        <ng-container cdkColumnDef="title">
          <mat-header-cell *cdkHeaderCellDef mat-sort-header class="title">{{'canton.name' | translate}}</mat-header-cell>
          <mat-cell *cdkCellDef="let eLearning" class="title" [routerLink]="'/pages/eLearning/preview'" [queryParams]="{id: eLearning.id}">
            <p class="text-truncate">{{eLearning.title}}</p>
          </mat-cell>
        </ng-container>

        <ng-container cdkColumnDef="organization" >
          <mat-header-cell *cdkHeaderCellDef mat-sort-header class="organization">{{'main.organization' | translate}}</mat-header-cell>
          <mat-cell *cdkCellDef="let eLearning" class="organization" [routerLink]="'/pages/eLearning/preview'" [queryParams]="{id: eLearning.id}">
            <p class="text-truncate">{{eLearning.organization.name}}</p>
          </mat-cell>
        </ng-container>

        <ng-container cdkColumnDef="recommended">
          <mat-header-cell *cdkHeaderCellDef mat-sort-header [ngClass]="'icons'">{{'event.recommended' | translate}}</mat-header-cell>
          <mat-cell *cdkCellDef="let eLearning" [ngClass]="'icons'" [routerLink]="'/pages/eLearning/preview'" [queryParams]="{id: eLearning.id}">
            @if (eLearning.recommendation.length) {
              <mat-icon class="green recommended">check</mat-icon>
            }
            @if (!eLearning?.recommendation?.length) {
              <mat-icon class="red recommended">close</mat-icon>
            }
          </mat-cell>
        </ng-container>

        <ng-container cdkColumnDef="recommendedBy">
          <mat-header-cell *cdkHeaderCellDef mat-sort-header class="recommended-by">{{'event.recommended_by' | translate}}</mat-header-cell>
          <mat-cell *cdkCellDef="let eLearning" class="recommended-by" [routerLink]="'/pages/eLearning/preview'" [queryParams]="{id: eLearning.id}">
            @if (eLearning.recommendation.length) {
              <p class="text-truncate">{{eLearning?.recommendation[0]?.user?.firstName + ' ' + eLearning?.recommendation[0]?.user?.lastName}}</p>
            }
          </mat-cell>
        </ng-container>

        <ng-container cdkColumnDef="recommendationText">
          <mat-header-cell *cdkHeaderCellDef mat-sort-header class="recommendation-text-cell">{{'event.recommendation_text' | translate}}</mat-header-cell>
          <mat-cell *cdkCellDef="let eLearning" class="recommendation-text recommendation-text-cell">
            @if (eLearning.recommendation.length) {
              <p class="text-truncate" [routerLink]="'/pages/eLearning/preview'" [queryParams]="{id: eLearning.id}"
              matTooltip="{{eLearning?.recommendation[0]?.recommendation_text}}">{{eLearning?.recommendation[0]?.recommendation_text}}</p>
            }
            @if (eLearning.recommendation.length && +userId === +eLearning.recommendation[0].userId) {
              <mat-icon
                (click)="editRecommendation($event, eLearning)"
              matTooltip="{{'event.edit_recommendation_text' | translate}}">edit</mat-icon>
            }

            @if (eLearning.recommendation.length && +userId !== +eLearning.recommendation[0].userId) {
              <mat-icon
                (click)="editRecommendation($event, eLearning, true)"
              matTooltip="{{'event.recommendation_text_preview' | translate}}">visibility</mat-icon>
            }
          </mat-cell>
        </ng-container>


        <mat-header-row *cdkHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>


        <mat-row *cdkRowDef="let event; columns: displayedColumns;"
          class="product"
          matRipple>
        </mat-row>

      </mat-table>
      @if (eLearnings.length === 0) {
        <div class="no-data-msg">
          <span class="mat-headline-6">{{'main.noData' | translate}}</span>
        </div>
      }
      <mat-paginator #paginator
        [length]="eLearningsLength"
        [pageIndex]="_pageIndex"
        [pageSize]="_perPage"
        [pageSizeOptions]="[10, 25, 50, 100]"
        (page)="changePageEmitter($event)">
      </mat-paginator>

    </div>
    <!-- / CONTENT -->

  </div>
</div>



